import { track, logError } from '@tracking';
import { getSearchId } from '@tracking/services/location.service';
import locationToString from '@commons/models/LocationPoint/mappers/toStringWithCityAndCountry';
import getLocationPointAreaName from '@commons/models/LocationPoint/getters/getAreaName';
import { getLocationPointCityName } from '@commons/models/LocationPoint';
import { getCountryName } from '@shared/selectors';
import getSessionId from '@core/reducers/user/selectors/getSessionId';

const EVENT_NAME = 'address.validated';

const trackAddressValidated = data => async (_, getState) => {
  try {
    const state = getState();
    const searchId = getSearchId(true);
    const dbSearchGuid = getSessionId(state);
    const countryName = getCountryName(state);
    const { latitude, longitude, id } = data;

    const payload = {
      locationAddress: locationToString(data, countryName),
      locationLat: latitude,
      locationLon: longitude,
      locationAreaName: getLocationPointAreaName(data),
      locationCity: getLocationPointCityName(data),
      addressId: id,
      searchId,
      dbSearchGuid,
    };
    track(EVENT_NAME, payload, {
      excludeFromCommon: ['locationLat', 'locationLon'],
    });
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackAddressValidated;
